
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
name: "station-info",
components: {Flexbox, FlexboxItem},
props: ["info"],
data() {
return {
data: "",

}
},
methods: {},
mounted() {
this.$nextTick(() => {

});
}
}



// WEBPACK FOOTER //
// ./src/components/StationInfo.vue